import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core'
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { LocationPinIcon } from 'asterX-UI/Icons'
import { useFilterStore } from 'context/SelectionStore/Manager/FilterStoreProvider.mager'
import AutoCompleteField from 'asterX-UI/Inputs/AutoCompleteField'
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck'
import LibraryAddCheckOutlinedIcon from '@material-ui/icons/LibraryAddCheckOutlined'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    marginRight: 'auto'
  },
  place: {
    display: 'flex',
    alignItems: 'center',
    color: PRIMARY_COLORS['700'],
    fontSize: 14
  },
  radioBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: 16,
    marginBottom: 20
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  rangeInputRight: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  },
  rangeInputLeft: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }
}))

const statusCodes = [
  { code: 'available', label: 'Доступно' },
  { code: 'com_register', label: 'Комиссионное оформление' }
]

const FilterDialog = ({ setIsFilterFullOPen }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const {
    dictionary,
    store: { filter },
    func: { onChangeFilter, onSearch, onResetFilter }
  } = useFilterStore()

  const onChange = e => {
    const { name, value } = e.target
    if (name === 'keyNumber') {
      return onChangeFilter({
        [name]:
          value
            ?.toString()
            ?.toLowerCase()
            .replace(/[^0-9]+/g, '') || ''
      })
    }
    onChangeFilter({ [name]: value })
  }

  const onSelectAllBranches = () => {
    if (dictionary.branchList.length === filter.branchCodes?.length) {
      return onChangeFilter({ branchCodes: [] })
    }
    onChangeFilter({
      branchCodes: dictionary.branchList.map(item => item.code)
    })
  }
  const handleClose = () => setIsFilterFullOPen(false)
  const onReset = () => {
    onResetFilter()
    handleClose()
  }
  const onSave = async () => {
    setLoading(true)
    await onSearch()
    handleClose()
    setLoading(false)
  }
  return (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <IconButton
            style={{
              color: GRAY_COLORS[400],
              padding: 0,
              marginRight: 8
            }}
            onClick={handleClose}
            size={'medium'}
          >
            <ChevronLeftIcon />
          </IconButton>
          <div className={classes.heading}>Фильтр</div>
          <div className={classes.place}>
            <LocationPinIcon />-
          </div>
        </div>
      }
    >
      <div className={classes.container}>
        <div className={classes.row}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel id="branchCodes-label">Филиал</InputLabel>
            <Select
              labelId="branchCodes-label"
              fullWidth
              label="Филиал"
              value={filter.branchCodes}
              onChange={onChange}
              multiple
              renderValue={value =>
                value?.length > 0
                  ? `${
                      dictionary.branchList?.find(v => v.code === value[0])
                        ?.name
                    } ${value.length > 1 ? '+' + (value.length - 1) : ''}`
                  : ''
              }
              name={'branchCodes'}
            >
              {dictionary.branchList?.map(v => (
                <MenuItem key={v.id} value={v.code}>
                  <Checkbox
                    color={'primary'}
                    checked={filter.branchCodes.indexOf(v.code) > -1}
                  />
                  <ListItemText primary={v.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <InputAdornment position={'start'}>
            <IconButton onClick={onSelectAllBranches}>
              {dictionary.branchList?.length === filter.branchCodes?.length ? (
                <LibraryAddCheckIcon color={'primary'} />
              ) : (
                <LibraryAddCheckOutlinedIcon />
              )}
            </IconButton>
          </InputAdornment>
        </div>
        <div className={classes.row}>
          <TextField
            label={'Цена от'}
            value={filter?.minPrice}
            name={'minPrice'}
            onChange={onChange}
            InputProps={{
              classes: {
                root: classes.rangeInputLeft
              }
            }}
          />
          <TextField
            label={'Цена до'}
            value={filter?.maxPrice}
            name={'maxPrice'}
            onChange={onChange}
            InputProps={{
              classes: {
                root: classes.rangeInputRight
              }
            }}
          />
        </div>
        <div className={classes.row}>
          <TextField
            label={'Пробег от'}
            value={filter?.minMileage}
            name={'minMileage'}
            onChange={onChange}
            InputProps={{
              classes: {
                root: classes.rangeInputLeft
              }
            }}
          />
          <TextField
            label={'Пробег до'}
            value={filter?.maxMileage}
            name={'maxMileage'}
            onChange={onChange}
            InputProps={{
              classes: {
                root: classes.rangeInputRight
              }
            }}
          />
        </div>
        <AutoCompleteField
          label={'Марка'}
          fullWidth
          value={filter?.markaNew}
          onChange={onChange}
          options={dictionary.brands}
          valueKey={'id'}
          name={'markaNew'}
        />

        <AutoCompleteField
          label={'Модель'}
          fullWidth
          disabled={!filter?.markaNew}
          value={filter?.modelNew}
          onChange={onChange}
          options={dictionary.models}
          valueKey={'id'}
          name={'modelNew'}
        />

        <div
          className={classes.row}
          style={{
            gap: 16
          }}
        >
          <TextField
            label={'Номер ключа'}
            fullWidth
            name={'keyNumber'}
            value={filter?.keyNumber}
            onChange={onChange}
          />

          <TextField
            label={'Код товара'}
            fullWidth
            name={'oneCId'}
            value={filter?.oneCId}
            onChange={onChange}
          />
        </div>
        <div
          className={classes.row}
          style={{
            gap: 16
          }}
        >
          <TextField
            label={'КПП'}
            select
            fullWidth
            name={'transmission'}
            value={filter?.transmission}
            onChange={onChange}
          >
            <MenuItem value={1}>{'Автомат'}</MenuItem>
            <MenuItem value={2}>{'Механика'}</MenuItem>
          </TextField>

          <FormControl fullWidth>
            <InputLabel id="bodyTypeCodes-label">Кузов</InputLabel>
            <Select
              labelId="bodyTypeCodes-label"
              fullWidth
              value={filter.bodyTypeCodes}
              onChange={onChange}
              multiple
              renderValue={value =>
                value?.length > 0
                  ? `${
                      dictionary.bodyTypes?.find(v => v.id === value[0])?.name
                    } ${value.length > 1 ? '+' + (value.length - 1) : ''}`
                  : ''
              }
              name={'bodyTypeCodes'}
            >
              {dictionary.bodyTypes?.map(v => (
                <MenuItem key={v.id} value={v.code}>
                  <Checkbox
                    color={'primary'}
                    checked={filter.bodyTypeCodes.indexOf(v.code) > -1}
                  />
                  <ListItemText primary={v.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className={classes.row}>
          <TextField
            label={'Год от'}
            name={'minYear'}
            value={filter?.minYear}
            onChange={onChange}
            InputProps={{
              classes: {
                root: classes.rangeInputLeft
              }
            }}
          />
          <TextField
            label={'Год до'}
            name={'maxYear'}
            value={filter?.maxYear}
            onChange={onChange}
            InputProps={{
              classes: {
                root: classes.rangeInputRight
              }
            }}
          />
        </div>
        <div
          className={classes.row}
          style={{
            gap: 16
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="dwheelTypeCodes-label">Тип привода</InputLabel>
            <Select
              labelId="dwheelTypeCodes-label"
              fullWidth
              value={filter.dwheelTypeCodes}
              onChange={onChange}
              multiple
              renderValue={value =>
                value?.length > 0
                  ? `${
                      dictionary.dwheelTypes?.find(v => v.id === value[0])?.code
                    } ${value.length > 1 ? '+' + (value.length - 1) : ''}`
                  : ''
              }
              name={'dwheelTypeCodes'}
            >
              {dictionary.dwheelTypes?.map(v => (
                <MenuItem key={v.id} value={v.code}>
                  <Checkbox
                    color={'primary'}
                    checked={filter.dwheelTypeCodes.indexOf(v.code) > -1}
                  />
                  <ListItemText primary={v.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="engineTypeCodes-label">Тип двигателя</InputLabel>
            <Select
              labelId="engineTypeCodes-label"
              fullWidth
              value={filter.engineTypeCodes}
              onChange={onChange}
              multiple
              renderValue={value =>
                value?.length > 0
                  ? `${
                      dictionary.engineTypes?.find(v => v.code === value[0])
                        ?.name
                    } ${value.length > 1 ? '+' + (value.length - 1) : ''}`
                  : ''
              }
              name={'engineTypeCodes'}
            >
              {dictionary.engineTypes?.map(v => (
                <MenuItem key={v.id} value={v.code}>
                  <Checkbox
                    color={'primary'}
                    checked={filter.engineTypeCodes.indexOf(v.code) > -1}
                  />
                  <ListItemText primary={v.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className={classes.row}>
          <TextField
            label={'Объем от'}
            name={'minEngineCapacity'}
            value={filter?.minEngineCapacity}
            onChange={onChange}
            InputProps={{
              classes: {
                root: classes.rangeInputLeft
              }
            }}
          />
          <TextField
            label={'Объем до'}
            name={'maxEngineCapacity'}
            value={filter?.maxEngineCapacity}
            onChange={onChange}
            InputProps={{
              classes: {
                root: classes.rangeInputRight
              }
            }}
          />
        </div>
        <div
          className={classes.row}
          style={{
            gap: 16
          }}
        >
          <TextField
            label={'Руль'}
            select
            fullWidth
            name={'steering'}
            value={filter?.steering}
            onChange={onChange}
          >
            <MenuItem value={1}>{'Левый'}</MenuItem>
            <MenuItem value={2}>{'Правый'}</MenuItem>
          </TextField>

          <FormControl fullWidth>
            <InputLabel id="colorCodes-label">Цвет</InputLabel>
            <Select
              labelId="colorCodes-label"
              fullWidth
              value={filter.colorCodes}
              onChange={onChange}
              multiple
              renderValue={value =>
                value?.length > 0
                  ? `${dictionary.colors?.find(v => v.id === value[0])?.code} ${
                      value.length > 1 ? '+' + (value.length - 1) : ''
                    }`
                  : ''
              }
              name={'colorCodes'}
            >
              {dictionary.colors?.map(v => (
                <MenuItem key={v.id} value={v.code}>
                  <Checkbox
                    color={'primary'}
                    checked={filter.colorCodes.indexOf(v.code) > -1}
                  />
                  <ListItemText primary={v.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className={classes.row}>
          <FormControl fullWidth>
            <InputLabel id="statusCodes-label">Статус авто</InputLabel>
            <Select
              labelId="statusTypes"
              fullWidth
              value={
                Array.isArray(filter.statusCodes) ? filter.statusCodes : []
              }
              onChange={onChange}
              multiple
              name={'statusCodes'}
              renderValue={value =>
                value?.length > 0
                  ? `${statusCodes?.find(v => v.code === value[0])?.label} ${
                      value.length > 1 ? '+' + (value.length - 1) : ''
                    }`
                  : ''
              }
            >
              {statusCodes?.map(v => (
                <MenuItem key={v.code} value={v.code}>
                  <Checkbox
                    color={'primary'}
                    checked={
                      Array.isArray(filter.statusCodes) &&
                      filter.statusCodes.includes(v.code)
                    }
                  />
                  <ListItemText primary={v.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div
          className={classes.row}
          style={{
            gap: 16
          }}
        >
          <FormControlLabel
            value={filter.hasPromo2}
            control={<Checkbox color={'primary'} />}
            onChange={({ target: { checked } }) =>
              onChangeFilter({ hasPromo2: checked })
            }
            label={'Скидка в Trade-in'}
          />
          <FormControlLabel
            value={filter.hasPromo1}
            control={<Checkbox color={'primary'} />}
            onChange={({ target: { checked } }) =>
              onChangeFilter({ hasPromo1: checked })
            }
            label={'Скидка по акции'}
          />
        </div>
        <div
          className={classes.row}
          style={{
            gap: 16
          }}
        >
          <Button fullWidth onClick={onReset} disabled={loading}>
            Сбросить
          </Button>
          <Button
            color={'primary'}
            variant={'contained'}
            fullWidth
            disabled={loading}
            onClick={onSave}
          >
            Применить
          </Button>
        </div>
      </div>
    </PageContainerMobile>
  )
}

export default FilterDialog
